import React, {useEffect, useState} from "react";
import getWeekOfMonth from "date-fns/getWeekOfMonth";
import ruLocale from "date-fns/locale/ru";
import {usePrevious} from "../CustomHook/usePrevious";
import Week from "./Week";



const Month = ({month, selectDate, type}) => {
    const [monthTitle, setMonthTitle] = useState()

    let weeks = []

    for (let i = 1; i < 7; i++) {
        let newWeek = Object.keys(month).filter(day => getWeekOfMonth(new Date(day), {
            weekStartsOn: 1,
            locale: ruLocale
        }) == i)
        if (newWeek.length > 0) {
            weeks.push(newWeek)
        }
    }

    const prevMonth = usePrevious(month)

    useEffect(() => {
        if (prevMonth !== month) {

            let monthsNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
            let thisDate = Object.keys(month)[0]
            let yearName = new Date(thisDate).getFullYear()
            let monthsName = monthsNames[new Date(thisDate).getMonth()]
            setMonthTitle(`${monthsName} ${yearName}`)
        }
    }, [month])


    return (
        <div className="col">
            <div className="calendar-month">
                <div className="calendar-month__title">{monthTitle}</div>

                <div className="calendar-month__body">
                    <section className="th">
                        <span>Пн</span>
                        <span>Вт</span>
                        <span>Ср</span>
                        <span>Чт</span>
                        <span>Пт</span>
                        <span>Сб</span>
                        <span>Вс</span>

                    </section>

                    {weeks.map((days, index) => {
                        return <Week key={index} days={days} month={month} selectDate={selectDate} type={type}/>
                    })}
                </div>



            </div>
        </div>
    )
}

export default Month